import React from 'react';
// eslint-disable-next-line
import agent from '../../agent';
import './Dashboard.css'
import '../../../node_modules/react-grid-layout/css/styles.css';
import '../../../node_modules/react-resizable/css/styles.css';
import WidgetHelper from './helpers/WidgetHelper'
import {Responsive, WidthProvider} from 'react-grid-layout';
import { Style } from 'radium';
const ResponsiveReactGridLayout = WidthProvider(Responsive);


class Dashboard extends React.Component {

  componentWillMount() {

    if(this.props.config) {
      const rowCount = this.props.config.numberOfRows;
      const rowHeight = this.calculateRowHeight(rowCount);
      const breakpoints = {lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0}

      this.setState({
        "rowCount":rowCount,
        "rowHeight":rowHeight,
        "breakpoints":breakpoints,
        "isDraggable":(window.innerWidth > 996),
        "breakpoint":this.calculateBreakpoint(breakpoints),
        "lglayout":this.props.config.layouts.lg
      })
    }
  }

  calculateBreakpoint(breakpoints) {
    var width = window.innerWidth;

    if(width >= breakpoints.lg) {
      return "lg";
    } else if (width >= breakpoints.md) {
      return "md";
    } else if(width >= breakpoints.sm) {
      return "sm";
    } else if(width >= breakpoints.xs) {
      return "xs";
    } else if(width >= breakpoints.xxs) {
      return "xxs";
    }

  }

  componentDidMount() {
    window.addEventListener('resize', this.recalculateHeight.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.recalculateHeight);
  }

  recalculateHeight() {

    const rowHeight = this.calculateRowHeight(this.state.rowCount)

    if(rowHeight !== this.state.rowHeight) {
      this.setState({
        ...this.state,
        rowHeight:rowHeight
      })
    }

  }

  calculateRowHeight(rowCount) {
    var rowHeight = (window.innerHeight - (this.props.config.horizontalGutter * (rowCount+1))) / rowCount;
    if(rowHeight < 125) {
      rowHeight = 125;
    }
    return Math.floor(rowHeight);
  }

  onBreakpointChange = breakpoint => {
    const rowCount = this.state.rowCount;
    const rowHeight = this.calculateRowHeight(rowCount)

    this.setState({
      ...this.state,
      rowHeight:rowHeight,
      isDraggable:(breakpoint === 'lg' || breakpoint === 'md'),
      breakpoint:breakpoint
    })
  }

  onLayoutChange = (currentLayout) => {
    const breakpoint = this.calculateBreakpoint(this.state.breakpoints)
    if(breakpoint !== "lg") {return;}

    const previousLayout = this.state.lglayout;
    const layoutChanged = this.hasLayoutChanged(currentLayout, previousLayout);

    const clonedNewLayout = JSON.parse(JSON.stringify(currentLayout))

    if(layoutChanged) {
      this.setState({
        ...this.state,
        lglayout:clonedNewLayout //clone currentLayout
      });

      if(this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(this.pushLayoutUpdateToNetSuite.bind(this), 5000);
    }
  }

  pushLayoutUpdateToNetSuite() {
    const configurationId = this.props.configurationId;
    const pageId = this.props.config.internalId;
    const layouts = {
      lg:this.state.lglayout
    }

    agent.View.updateLayout(configurationId, pageId, layouts).then(
      res => {
        this.props.layoutUpdated(pageId, layouts.lg);
      },
      error => {
        if(error.status === 401 || error.status === 403) {
          window.localStorage.setItem('jwt', '');
          window.localStorage.setItem('configurationId', '');
          agent.setToken(null);
          window.location.replace("#/login")
        }
      }
    )
  }

  hasLayoutChanged(currentLayout, previousLayout) {
    var layoutChanged = false;

    currentLayout.forEach((widget)=>{
      previousLayout.forEach((previousWidget)=>{
        if(previousWidget.i === widget.i) {
          if(previousWidget.x !== widget.x || previousWidget.y !== widget.y) {
            layoutChanged = true;
            return;
          }
        }
      })

      if(layoutChanged) {return;}
    })

    return layoutChanged;
  }

  calculateStyleSheetBreakPoint() {
    var width = window.innerWidth;

    if(width >= 1900) {
      return "lg";
    } else if (width >= 1500) {
      return "md";
    } else if(width >= 1200) {
      return "sm";
    } else if(width >= 992) {
      return "xs";
    } else {
      return "xxs";
    }
  }

  renderStyleSheet() {
    if(this.props.config && this.props.config.fontSizes) {
      const { fontSizes } = this.props.config;
      let breakpoint = this.calculateStyleSheetBreakPoint();

      let fontSize;

      if(breakpoint === 'xs' || breakpoint === 'xxs') {
        fontSize = fontSizes['sm'];
      } else {
        fontSize = fontSizes[breakpoint]
      }

      let h1FontSize = fontSize;
      let h2FontSize = h1FontSize - 0.1;
      let pFontSize = h1FontSize - 1.7;

      if(breakpoint === 'md') {
        h2FontSize = h1FontSize - 0.5;
        pFontSize = h1FontSize - 1.0;
      } else if(breakpoint === 'sm') {
        h2FontSize = h1FontSize - 0.2;
        pFontSize = h1FontSize - 0.7;
      } else if(breakpoint === 'xs') {
        h1FontSize = h1FontSize - 0.5
        h2FontSize = h1FontSize - 0.1;
      } else if(breakpoint === 'xxs') {
        h1FontSize = h1FontSize - 0.6
        h2FontSize = h1FontSize - 0.1;
      }

      const styleRules = {
        'h1': {
          fontSize: `${h1FontSize}rem`
        },
        'h2': {
          fontSize: `${h2FontSize}rem`
        }
      }

      if(breakpoint === 'lg' || breakpoint === 'md' || breakpoint === 'sm') {
        styleRules['p'] = {
          fontSize: `${pFontSize}rem`
        }
      }

      return (<Style rules={styleRules} />);
    }
  }

  render() {
    if(this.props.config) {

      const config = this.props.config;
      var layouts = config.layouts;
      var widgets = config.widgets;
      const cols = config.cols;

      var widgetHelper = new WidgetHelper(config, this.state.rowHeight, this.state.lglayout)

      return (
        <div className="dashboard" style={{"background":config.pageBackgroundColour}}>
          <ResponsiveReactGridLayout
            className="layout"
            layouts={layouts}
            breakpoints={this.state.breakpoints}
            cols={cols}
            onBreakpointChange={this.onBreakpointChange}
            onLayoutChange={this.onLayoutChange}
            measureBeforeMount={true}
            rowHeight={this.state.rowHeight}
            maxRows={this.state.rowCount}
            isDraggable={this.state.isDraggable}
            margin={[config.horizontalGutter,config.verticalGutter]}
          >
              {widgetHelper.renderWidgets(widgets, config.language)}
          </ResponsiveReactGridLayout>
          {this.renderStyleSheet()}
        </div>
      )

    } else {
      return null;
    }
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.js